import {
  CLOSE_OPEN_POPUP,
  INNER_FOLDER_UPDATE_DETAILS,
  INNER_PREV_SELECTED,
  SET_HIERARCHY_FOLDER_DATA,
  SET_INSIDE_FOLDER_DATA,
  SET_INSIDE_FOLDER_FOLDER_DATA,
  SET_INSIDE_FOLDER_ID,
  SET_OPEN_POPUP_DAM,
  SET_OPEN_POPUP_DATA,
  SET_SELECT_ASSET_DATA,
  SET_SELECT_FOLDER_DATA,
} from './types';

export const setOpenPopup = (data) => ({
  type: SET_OPEN_POPUP_DAM,
  payload: data,
});

export const clostOpenPopup = (data) => ({
  type: CLOSE_OPEN_POPUP,
  payload: data,
});

export const setOpenPopupData = (data) => ({
  type: SET_OPEN_POPUP_DATA,
  payload: data,
});

export const setInsideFolderData = (data) => ({
  type: SET_INSIDE_FOLDER_DATA,
  payload: data,
});

export const setInsideFolderId = (data) => ({
  type: SET_INSIDE_FOLDER_ID,
  payload: data,
});

export const setInsideFolderFolderData = (data) => ({
  type: SET_INSIDE_FOLDER_FOLDER_DATA,
  payload: data,
});

export const SetSelctedFoldersData = (data) => ({
  type: SET_SELECT_FOLDER_DATA,
  payload: data,
});

export const SelectedAssetData = (data) => {
  return {
    type: SET_SELECT_ASSET_DATA,
    payload: data,
  };
};

export const setHierarchyFolderData = (data) => ({
  type: SET_HIERARCHY_FOLDER_DATA,
  payload: data,
});

export const setInnerFolderDetails = (data) => ({
  type: INNER_FOLDER_UPDATE_DETAILS,
  payload: data,
});

export const SetInnerPrevSelected = (data) => ({
  type: INNER_PREV_SELECTED,
  payload: data,
});
